import React, { lazy } from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const scrollToProductOptions = () => {
    // Check if product options section exists
    const productOptionsSection = document.getElementById('product-options');
    if (productOptionsSection) {
      // If it exists, scroll to it
      productOptionsSection.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      // If it doesn't exist yet (hidden due to timer), show a message
      alert('Our special offers will be available soon! Please continue exploring our product.');
      // Optionally, scroll to top of page
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full py-12 bg-white px-4" data-id="element-380">
      <div className="max-w-6xl mx-auto" data-id="element-381">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-382">
          Real Men Who Saved Their Hairlines
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-383">
          {/* Testimonial 1 */}
          <div className="bg-gray-50 p-6 rounded-lg" data-id="element-384">
            <div className="flex justify-center mb-4" data-id="element-385">
              <div className="w-20 h-20 rounded-full overflow-hidden" data-id="element-386">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iZUJmeywF2mdWWLkga2VMu/ChatGPT_Image_30_%CE%99%CE%BF%CF%85%CE%BB_2025%2C_06_22_15_%CE%BC.%CE%BC..webp" alt="Eric testimonial" className="w-full h-full object-cover" loading="lazy" width="80" height="80" decoding="async" data-id="element-387" />
              </div>
            </div>
            <div className="flex justify-center mb-2" data-id="element-388">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-400 fill-yellow-400" size={20} data-id="element-389" />)}
            </div>
            <h4 className="font-bold text-center mb-2" data-id="element-390">Eric, Los Angeles</h4>
            <p className="text-center text-sm" data-id="element-391">
              "My barber asked what I was doing differently! I've been going to
              the same barber for years, and he's seen my hair get thinner with
              every visit. After using Hair Growth Oil 3.0 for about two months,
              he literally asked me, 'What are you doing differently? Your hair
              is looking way thicker!'"
            </p>
          </div>
          {/* Testimonial 2 */}
          <div className="bg-gray-50 p-6 rounded-lg" data-id="element-392">
            <div className="flex justify-center mb-4" data-id="element-393">
              <div className="w-20 h-20 rounded-full overflow-hidden" data-id="element-394">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kTyWT9JvgpCbjPZM166rUU/fayiz-musthafa-sMR__Unqh5A-unsplash.webp" alt="Marcus testimonial" className="w-full h-full object-cover" loading="lazy" width="80" height="80" decoding="async" data-id="element-395" />
              </div>
            </div>
            <div className="flex justify-center mb-2" data-id="element-396">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-400 fill-yellow-400" size={20} data-id="element-397" />)}
            </div>
            <h4 className="font-bold text-center mb-2" data-id="element-398">Marcus, Miami</h4>
            <p className="text-center text-sm" data-id="element-399">
              "Baby hairs after 6 weeks! I've been dealing with hair loss since
              29 and tried everything. Minoxidil was too greasy and annoying. I
              was scared of Finasteride after reading horror stories. After
              following this Indonesian ritual, I'm seeing baby hair after 6
              weeks."
            </p>
          </div>
          {/* Testimonial 3 */}
          <div className="bg-gray-50 p-6 rounded-lg" data-id="element-400">
            <div className="flex justify-center mb-4" data-id="element-401">
              <div className="w-20 h-20 rounded-full overflow-hidden" data-id="element-402">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a7Ac51NrfzfXpHJ7jWxumk/drew-hays-agGIKYs4mYs-unsplash.webp" alt="Alex testimonial" className="w-full h-full object-cover" loading="lazy" width="80" height="80" decoding="async" data-id="element-403" />
              </div>
            </div>
            <div className="flex justify-center mb-2" data-id="element-404">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-400 fill-yellow-400" size={20} data-id="element-405" />)}
            </div>
            <h4 className="font-bold text-center mb-2" data-id="element-406">Alex, 47 years old</h4>
            <p className="text-center text-sm" data-id="element-407">
              "First thing that made scientific sense. I tried every supplement
              and 'miracle' treatment for 5 years. Nothing worked until I
              followed the advice in this formula. It's the first thing that
              made scientific sense AND delivered results. I feel like myself
              again."
            </p>
          </div>
        </div>
        <div className="text-center mt-10" data-id="element-408">
          <p className="text-sm text-gray-600 mb-4" data-id="element-409">
            Join over 100,000 satisfied customers
          </p>
          <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-full" onClick={scrollToProductOptions} data-id="element-410">
            CLAIM MY HAIR GROWTH OIL 3.0 NOW
          </button>
        </div>
      </div>
    </section>;
}
export default {
  TestimonialsSection
};